import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { registerCompany } from "features/company/companyActions";
import { setNotification } from "features/Notification/notificationSlice";

function CompanyForm({ userInfo, selectedIndex, setSelectedIndex }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [isLoading, setLoading] = useState(false);

  const { error, success } = useSelector((state) => state.company);

  const onSubmit = async (data) => {
    setLoading(true);
    const company = { ...data, userId: userInfo.id };

    document.querySelectorAll(".needs-validation").forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });

    await dispatch(registerCompany(company))
      .then((res) => {
        if (res.type === "companies/create/rejected") {
          dispatch(
            setNotification({
              message: res.payload,
              type: "error",
            })
          );
          setLoading(false);
        }
        if (res.type === "companies/create/fulfilled") {
          navigate("/app/client-login/", { replace: true });
          setSelectedIndex(selectedIndex + 1);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        dispatch(
          setNotification({
            message: err.message,
            type: "error",
          })
        );
      });
  };

  useEffect(() => {
    // document.querySelectorAll(".needs-validation").forEach((form) => {
    //   form.addEventListener(
    //     "submit",
    //     (event) => {
    //       if (!form.checkValidity()) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //       }
    //       form.classList.add("was-validated");
    //     },
    //     false
    //   );
    // });
    // if (success) {
    //   setLoading(false);
    //   navigate("/dashboard", { replace: true });
    // }
    // if (error) {
    //   dispatch(
    //     setNotification({
    //       message: error,
    //       type: "error",
    //     })
    //   );
    // }
  }, [success]);

  return (
    <form
      id="companyForm"
      method="post"
      className={`form-horizontal needs-validation`}
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className="row">
        <div className="col-lg-4">
          <label htmlFor="companyName">Company Name</label>
        </div>

        <div className="col-lg-8">
          <div className="mb-3">
            <input
              className="form-control"
              placeholder="Company Name"
              {...register("name")}
              required
            />
            <div className="invalid-feedback">Please enter company name.</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4">
          <label htmlFor="street">Office Address</label>
        </div>

        <div className="col-lg-8">
          <div className="mb-3">
            <input
              id="street"
              className="form-control"
              placeholder="Street"
              {...register("street")}
              required
            />
          </div>
        </div>

        <div className="invalid-feedback">Please enter company name.</div>
      </div>

      <div className="row">
        <div className="col-lg-4"></div>

        <div className="col-lg-4">
          <div className="mb-3">
            <input
              id="city"
              className="form-control"
              placeholder="City"
              {...register("city")}
              required
            />
          </div>
        </div>

        <div className="col-lg-4">
          <div className="mb-3">
            <input
              id="state"
              className="form-control"
              placeholder="State"
              {...register("state")}
              required
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4"></div>

        <div className="col-lg-4">
          <div className="mb-3">
            <input
              id="zip"
              className="form-control"
              placeholder="Zip"
              {...register("zip")}
              required
            />
          </div>
        </div>
      </div>

      <ul className="pager wizard mb-0 list-inline">
        <li className="next list-inline-item float-end">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {!isLoading ? (
              <>
                Next <i className="mdi mdi-arrow-right ms-1"></i>
              </>
            ) : (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Creating Company...
              </>
            )}
          </button>
        </li>
      </ul>
    </form>
  );
}

export default CompanyForm;
